export const faqData = [
  {
    question: '北条麻妃电影全集精选网站是什么？',
    answer: '这是一个专注于北条麻妃电影作品的资源导航平台，为影迷提供最全面的北条麻妃电影信息汇总，包括高清影片资源介绍、经典代表作推荐、分类浏览和在线观看指南。'
  },
  {
    question: '如何在网站上找到我想要的北条麻妃电影？',
    answer: '您可以通过首页的分类导航（精选推荐、经典系列、最新作品、高分好评、独家珍藏）浏览不同类型的作品。也可以使用搜索功能输入作品名称或关键词快速定位。'
  },
  {
    question: '网站上的电影资源清晰度如何？',
    answer: '我们收录的北条麻妃电影资源均为高清画质，大部分作品提供1080P全高清版本，最新的作品更提供4K超高清版本，确保影迷获得最佳的观影体验。'
  },
  {
    question: '北条麻妃有哪些必看的经典代表作？',
    answer: '北条麻妃最受影迷推崇的经典作品包括《美熟女画報》《昭和の女》《人妻の秘密》《未亡人の決意》等。这些作品不仅在影迷中获得极高评分，也展现了北条麻妃在不同时期的演技巅峰。'
  },
  {
    question: '网站是否提供在线观看服务？',
    answer: '本网站主要提供北条麻妃电影作品的资源信息和导航服务。我们为每部作品提供详细的介绍、评分、分类标签等信息，帮助影迷快速了解作品内容并找到观看渠道。'
  },
  {
    question: '北条麻妃的最新作品在哪里可以看到？',
    answer: '您可以在网站的"最新作品"分类中查看北条麻妃最新上映的作品信息。我们会在第一时间更新北条麻妃的新作动态，包括上映日期、作品简介和评分等信息。'
  },
  {
    question: '如何联系网站管理员？',
    answer: '您可以通过"关于我们"页面中的联系表单与我们取得联系。如果您有任何问题、建议或合作意向，欢迎随时联系我们，我们会在24小时内回复。'
  },
  {
    question: '北条麻妃作品适合什么样的观众？',
    answer: '北条麻妃的作品以其精湛的演技、精美的画面和深刻的剧情著称，适合欣赏成熟女性魅力、喜欢日本影视艺术以及对表演艺术感兴趣的观众。她的作品涵盖了多种题材和风格，能满足不同观众的需求。'
  }
];